import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { MdErrorOutline } from 'react-icons/md';
import Modal from '../../../../components/Modal/Modal';
import TextField from '../../../../components/TextField';
import Button from '../../../../components/Button/Button';
import { useTheme } from 'styled-components';
import SelectInput from '../../../../components/SelectOptions';
import { useEffect, useState } from 'react';
import { ButtonContainer, SmallerModal } from '../../../GerenciarClientes/styles/GerenciarClientes.styles';
import api from '../../../../utils/services/api';
import { pixRefundCancelActions, pixRefundCloseActions } from '../../../../store/fetchActions/pixRefundActions';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';

const ModalPixRefundRequest = ({ open, close, data }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { idRefund, idTypeRefund, isClaimant } = data;

  const { handleSubmit, control } = useForm({});
  const [analysisResult, setAnalysisResult] = useState({
    analysis: [],
    rejectReason: [],
  });

  useEffect(async () => {
    const [analysisData, rejectReasonData] = await Promise.all([
      api.get('/admin/pix/tipos/analise/devolucao'),
      api.get('/admin/pix/tipos/razao/rejeicao/devolucao'),
    ]);

    setAnalysisResult({
      analysis: analysisData.data?.data,
      rejectReason: rejectReasonData.data?.data,
    });
  }, []);

  const submitForm = (data) => {
    const param = {
      ID_SOLICITACAO: idRefund,
      MOTIVO: data.analysisResult,
      RAZAO_REJEICAO: data.reasonRejected,
      JUSTIFICATIVA: data?.justificativa,
    };

    if (isClaimant) {
      return dispatch(pixRefundCancelActions(param, close));
    }
    dispatch(pixRefundCloseActions(param, close));
  };

  return (
    <Modal open={open} close={close}>
      <SmallerModal>
        <MdErrorOutline color={theme.colors.nutBrown} size={'5.944vw'} />
        <h3>Responder solicitação de devolução</h3>
        <form onSubmit={handleSubmit(submitForm)}>
          <Grid container gap={3}>
            <SelectInput
              label="Análise"
              name={'analysisResult'}
              width={'15.042vw'}
              control={control}
              options={analysisResult.analysis}
              initialValue={0}
            />
            {idTypeRefund == 2 && (
              <SelectInput
                label="Motivo da rejeição"
                name={'reasonRejected'}
                width={'15.042vw'}
                control={control}
                options={analysisResult.rejectReason}
                initialValue={0}
              />
            )}
          </Grid>
          <h4>Justificativa</h4>
          <TextField
            variant={'outlined'}
            name={'justificativa'}
            width={'31.642vw'}
            multiline={true}
            minRows={3}
            // size="large"
            control={control}
          />
          <Grid sx={{ display: 'flex', justifyContent: 'space-between', mt: '2.5vw', mb: '2.5vw' }}>
            <Button
              backgroundcolor={theme.colors.buttonBack}
              width={'14.792vw'}
              height={'3.125vw'}
              hoverbgcolor={theme.colors.buttonBackHover}
              hovercolor={theme.colors.buttonBackHoverText}
              mycolor={theme.colors.buttonBackText}
              onClick={close}
            >
              <span>Voltar</span>
            </Button>
            <Button
              backgroundcolor={theme.colors.buttonConfirm}
              width={'14.792vw'}
              height={'3.125vw'}
              hoverbgcolor={theme.colors.buttonNegadedHover}
              hovercolor={theme.colors.buttonNegadedHoverText}
              mycolor={theme.colors.buttonNegadedText}
              type="submit"
            >
              <span>Confirmar</span>
            </Button>
          </Grid>
        </form>
      </SmallerModal>
    </Modal>
  );
};

export default ModalPixRefundRequest;
